module.exports = __webpack_public_path__ + "src/assets/images/dx_logo.png";